module.exports = "# Scoreboard Recap\n\n## Content\n\n### Check out the scoreboard to see who's in the lead!\n\n## Notes\n\n&nbsp;\n\n# Earn More Points\n\n## Content\n\n### Everyone has a chance to earn more points!\n* Take home your Mission Files.\n* Do your missions and record what you did.\n* Listen & participate in class!\n\n## Notes\n\n&nbsp;\n\n# Farewell\n\n## Content\n\n### Keep the fun going!\n\n#### Visit *AndGoober.com* for games and activities\n\nGo to the next slide to finish the level\n\n## Notes\nTo finish, go to the next slide and click 'Click to end level'.\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/90_finish/finish.md
// module id = 1871
// module chunks = 2